export const FILTER_UBIQUA_INLINE_COUNT = 3

export const FILTER_UBIQUA_TOOLBAR_BREAKPOINTS = {
  hideThird: 1180,
  compactMore: 960,
  hideFirst: 760
}

export function getVisibleInlineFilterCount(
  width,
  configuredCount = FILTER_UBIQUA_INLINE_COUNT
) {
  const configured = Math.max(0, Number(configuredCount) || 0)
  if (!Number.isFinite(width)) return configured
  if (width < FILTER_UBIQUA_TOOLBAR_BREAKPOINTS.hideFirst) return 0
  if (width < FILTER_UBIQUA_TOOLBAR_BREAKPOINTS.compactMore) return Math.min(1, configured)
  if (width < FILTER_UBIQUA_TOOLBAR_BREAKPOINTS.hideThird) return Math.min(2, configured)
  return configured
}

export function shouldCompactFilterToolbar(width) {
  return Number.isFinite(width) && width < FILTER_UBIQUA_TOOLBAR_BREAKPOINTS.compactMore
}
